import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { DutyExchangeItem } from './DutyExchangeItem';

export const DutyExchange = types.compose(
  BaseEntity,
  types.model('DutyExchange', {
    dutyExchangeId: types.identifierNumber,
    requestorId: types.integer,
    recipientId: types.optional(types.integer, -1),
    withAgreement: types.boolean,
    withSubstitution: types.boolean,
    comment: types.string,
    dutyExchangeItems: types.optional(types.array(DutyExchangeItem), []),
  }),
);
